//#region ImportsSection
import { useState } from "react";
import swal from "sweetalert";
import { GetSelectedLanguage } from "../../helper/Method";
import { GetLanguageString } from "../../helper/Components";
import { t } from "i18next";
import {
  FormGroup,
  Form,
  Label,
  Input,
  Button,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Modal,
  ModalHeader,
} from "reactstrap";
import { isUrdu, LoadingSpinner } from "../../../constants/const";
import Draggable from "react-draggable";
import ApiGeneralConfig from "./ApiGeneralConfig";
//#endregion ImportsSection
const EditGeneralConfig = ({
  selectedProgress,
  setEditModal,
  refresh,
  setRefresh,
}) => {
  //#region StateSection
  const [formData, setFormData] = useState(selectedProgress);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  //#endregion StateSection

  //#region functionSection

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.key = formData.key ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );
    temp.value = formData.value ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setButtonDisable(true);
      ApiGeneralConfig()
        .Update(formData.id, formData)
        .then((res) => {
          console.log(res);
          swal({
              title: t("general_config_edited"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });

          setRefresh(!refresh);
          setEditModal(false);
          setLoading(false);
          setButtonDisable(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
          setButtonDisable(false);
        });
    }
  };
  //#endregion functionSection

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="general_config_edit" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>
                  <GetLanguageString props="general_config_key" />
                </Label>
                <Input
                  disabled
                  type="text"
                  name="key"
                  className={
                    isUrdu(formData.key) ? "no-drag ur" : "no-drag"
                  }
                  value={formData.key}
                  onChange={handleInputChange}
                  {...(errors?.key && { invalid: true })}
                />
                {errors?.key && (
                  <FormFeedback>
                    <h4>{errors?.key}</h4>
                  </FormFeedback>
                )}
              </FormGroup><FormGroup>
                <Label>
                  <GetLanguageString props="general_config_value" />
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="value"
                  className={
                    isUrdu(formData.value) ? "no-drag ur" : "no-drag"
                  }
                  value={formData.value}
                  onChange={handleInputChange}
                  {...(errors?.value && { invalid: true })}
                />
                {errors?.value && (
                  <FormFeedback>
                    <h4>{errors?.value}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => setEditModal(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit" disabled={buttonDisable}>
                <GetLanguageString props="common_save" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default EditGeneralConfig;
